<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="4"
            categoryName="Trafo"
            categorySectionIcon="fa-bolt"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'trafo',
    components: { BaseInventory }
}
</script>
